export const HATCH_ENABLED = true;

const hatchConfig = {
  apiKey: '52431',
  baseUrl: 'https://gethatch.com/iceleads_rest/affiliate',
  additionalParams: '&sort=group_name',
  cid_water: 'watersystems',
  cid_shower: 'showerconfigurator',
  region: 'NL'
};

export default hatchConfig;



// WEBPACK FOOTER //
// ./src/constants/hatchConfig.js